// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ImgResponsive":"bcq_a bik_a bik_q bik_j bik_wl bik_bj","ImgResponsive__img":"bcq_b bik_b bik_ql"};